import React from 'react';
import { withStyles } from 'material-ui/styles';
import UITuple from '../../core/ui/tuple.js';

const styles = theme => ({
  link : {
    textDecoration: 'none',
    color: 'black',
  },
  title: {
    fontSize: 15,
    lineHeight: '20px',
  },
  title2: {
    fontSize: 12,
    lineHeight: '15px',
    paddingBottom: 2,
    paddingTop: 2,
    textDecoration: 'underline', 
  },
  block: {
    display: 'block',
    fontSize: 10, 
    lineHeight: '15px',
  },
});


class InfoCardPiece extends React.Component {
  handleListItemClick(url) {
    if(!url) return;
    var win = window.open(url, '_blank');
    win.focus();

    const uri = '/google/q/this';
    const params = {q : '', url: url};
    this.props.server.get(uri, params, null);
    return false;
  }
  
  render() {
    var key = 0;
    const classes = this.props.classes;
    const data = this.props.data;
    const link = data.link;
    const body = 
      <div>
          <UITuple className={classes.block} tuple={data.title}/>
          <UITuple className={classes.block} tuple={data.author}/>
          <UITuple className={classes.block} tuple={data.type}/>
          <UITuple className={classes.block} tuple={data.twitter} link={`https://twitter.com/${(data.twitter) ? data.twitter.value : ''}`}/>
          <UITuple className={classes.block} tuple={data.instagram} link={`https://instagram.com/${(data.instagram) ? data.instagram.value : ''}`}/>
          <UITuple className={classes.block} tuple={data.person_name}/>
          <UITuple className={classes.block} tuple={data.organization_name}/>
          <UITuple className={classes.block} tuple={data.organization_department}/>
          <UITuple className={classes.block} tuple={data.organization_city}/>
          <UITuple className={classes.block} tuple={data.organization_country}/>
          <UITuple className={classes.block} tuple={data.address_street}/>
          <UITuple className={classes.block} tuple={data.address_locality}/>
          <UITuple className={classes.block} tuple={data.address_region}/>
          <UITuple className={classes.block} tuple={data.address_code}/>
          <UITuple className={classes.block} tuple={data.address_country}/>
          <UITuple className={classes.block} tuple={data.business_name}/>
          <UITuple className={classes.block} tuple={data.business_telephone}/>
          <UITuple className={classes.block} tuple={data.business_price}/>
          <UITuple className={classes.block} tuple={data.tvseries_episode_name}/>
          <UITuple className={classes.block} tuple={data.tvseries_episode_number}/>
          <UITuple className={classes.block} tuple={data.tvseries_name}/>
          <UITuple className={classes.block} tuple={data.tvseries_rating}/>
          <UITuple className={classes.block} tuple={data.tvseries_audience}/>
          <UITuple className={classes.block} tuple={data.tvseries_duration} format='duration'/>
          <UITuple className={classes.block} tuple={data.tvseries_genre}/>
          <UITuple className={classes.block} tuple={data.tvseries_trailer}/>
          <UITuple className={classes.block} tuple={data.tvseries_headline}/>
          <UITuple className={classes.block} tuple={data.tvseries_description}/>
          <UITuple className={classes.block} tuple={data.tvseries_published} format='date'/>
          <UITuple className={classes.block} tuple={data.tvseries_provider}/>
          <UITuple className={classes.block} tuple={data.tvseries_awards}/>
          <UITuple className={classes.block} tuple={data.tvseries_keywords}/>
          <UITuple className={classes.block} tuple={data.keywords}/>
      </div>;    

    return (
      body
    );
  }

}

export default withStyles(styles)(InfoCardPiece);


// WEBPACK FOOTER //
// ./src/search/display/infocard_piece.js